module.exports = __webpack_public_path__ + "img/fan.3f82580b.svg";